// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"CharacterSheetMenuButton_fullWidth_144Nl"};